import { render, staticRenderFns } from "./RecognitionHandlerSidebar.vue?vue&type=template&id=bc5b827a&scoped=true&"
import script from "./RecognitionHandlerSidebar.vue?vue&type=script&lang=js&"
export * from "./RecognitionHandlerSidebar.vue?vue&type=script&lang=js&"
import style0 from "./RecognitionHandlerSidebar.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./RecognitionHandlerSidebar.vue?vue&type=style&index=1&id=bc5b827a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc5b827a",
  null
  
)

export default component.exports